import React from "react";
import "../../Style/OurSupport.css";
import support1 from "../../Images/HomePageImages/1.jpg";
import support2 from "../../Images/HomePageImages/2.jpg";
import support3 from "../../Images/HomePageImages/3.jpg";
import support4 from "../../Images/HomePageImages/4.png";
import support5 from "../../Images/HomePageImages/5.png";
import support6 from "../../Images/HomePageImages/UltraBuildingCo-Logo-Dark.png";
import support7 from "../../Images/HomePageImages/support7.png";

function OurSupport() {
  return (
    <div className="ourSupport">
      <div className="container-xxl">
        <div className="support-header text-center">
          <span className="support-pill">Our Partners</span>
          <h3>Who We Support</h3>
          <p className="support-subtitle">
            Henneberry Property Group helps buyers, sellers, landlords, and investors with expert Sydney real estate guidance, from apartments for sale and rental properties to luxury homes and property management.
          </p>
        </div>
        <div className="support-logos-flex">
          <a
            href="https://www.georgecapital.com.au/"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support1} alt="George Capital" />
          </a>

          <a
            href="https://marqueskinsolutions.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support3} alt="Marque Skin Solutions" />
          </a>

          <a
            href="https://leifproducts.com/?gad_source=1&gclid=Cj0KCQjwq_G1BhCSARIsACc7Nxot2BDmaGCpbOVYk_9SCDhC_u6GItUqYtgNWI5lD7CupGvGLNFdg8AaAoZQEALw_wcB"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support4} alt="Leif Products" />
          </a>

          <a
            href="https://mnmllife.co/pages/the-science"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support2} alt="MNML" />
          </a>

          <a
            href="https://www.funguofelicitykenya.com"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support5} alt="Funguo Kenya" />
          </a>

          <a
            href="https://ultrabuilding.co/about/"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support6} alt="Ultra Building Co" />
          </a>

          <a
            href="https://wetcanteenbottlingco.com.au/"
            target="_blank"
            rel="noopener noreferrer"
            className="support-logo-card"
          >
            <img src={support7} alt="Wet Canteen Bottling Co" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default OurSupport;

